import { Num, Row } from "./shared";

export const CornersTab = ({ d, setPart }) => (
  <div
    className="mt-6 rounded-lg border border-zinc-800 bg-zinc-900 p-5"
    data-testid="drawing-corners"
  >
    <Row label="Clipped corner size">
      <Num
        testId="corners-clip"
        value={d.corners.clip_in}
        onChange={(v) => setPart("corners", { clip_in: v })}
        suffix="in"
      />
    </Row>
    <Row label="Radius corner size">
      <Num
        testId="corners-radius"
        value={d.corners.radius_in}
        onChange={(v) => setPart("corners", { radius_in: v })}
        suffix="in"
      />
    </Row>
    <Row label="Clipped corner charge">
      <Num
        testId="corners-clip-charge"
        value={d.corners.clip_charge}
        onChange={(v) => setPart("corners", { clip_charge: v })}
        suffix="$ each"
      />
    </Row>
    <Row label="Radius corner charge">
      <Num
        testId="corners-radius-charge"
        value={d.corners.radius_charge}
        onChange={(v) => setPart("corners", { radius_charge: v })}
        suffix="$ each"
      />
    </Row>
  </div>
);
